import { Link } from "react-router-dom";
import "./EmptyState.css";

function EmptyState({ icon, title, description, ctaLabel, ctaTo, onCtaClick }) {
  return (
    <div className="pa-empty prose-center">
      {icon && (
        <span className="pa-empty__icon" aria-hidden="true">
          <i className={`bi ${icon}`}></i>
        </span>
      )}
      {title && <h2 className="pa-empty__title">{title}</h2>}
      {description && <p className="pa-empty__text">{description}</p>}
      {ctaLabel && ctaTo && (
        <Link to={ctaTo} className="pa-btn pa-btn--primary">
          {ctaLabel}
        </Link>
      )}
      {ctaLabel && onCtaClick && !ctaTo && (
        <button
          type="button"
          className="pa-btn pa-btn--ghost"
          onClick={onCtaClick}
        >
          {ctaLabel}
        </button>
      )}
    </div>
  );
}

export default EmptyState;
